<mat-checkbox
  eurogardStopPropagation
  (change)="selectRow.selectionModel.toggle(element)"
  [checked]="selectRow.selectionModel.isSelected(element)">
</mat-checkbox>
